import React, { Component } from 'react';
import { IRequestedDataModalProps } from '../../types/PropTypes';
import { Modal } from 'react-bootstrap';
import JsonView from 'react18-json-view';
import 'react18-json-view/src/style.css';
class RequestedDataModal extends Component<IRequestedDataModalProps> {
    render() {
        const { t, showModal, closeModal, requestedData } = this.props;
        return (
            <Modal className="error-meesage-modal" show={showModal} onHide={() => closeModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('driver.label.requestedData')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="App">
                        <JsonView src={JSON.parse(requestedData)} theme="vscode" className="custom-json-view" />
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}
export default RequestedDataModal;
